import { render } from "./ToolSubmissionThankYouView.vue?vue&type=template&id=2c362002"
import script from "./ToolSubmissionThankYouView.vue?vue&type=script&lang=js"
export * from "./ToolSubmissionThankYouView.vue?vue&type=script&lang=js"

import "./ToolSubmissionThankYouView.vue?vue&type=style&index=0&id=2c362002&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__